import './App.css';
import HealthCheck from './components/HealthCheck';

function App() {
  return (
    <>
    <div className="App">
     <HealthCheck />
    </div>
    </>
  );
}

export default App;
